import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';

// Composants existants – assurez-vous qu'ils utilisent le nouveau thème white/beige/gold/glass
import BannerArea from '../../components/Carousel/BannerArea';
import MainContainer from '../../components/Carousel/MainContainer';
import MainContainer2 from '../../components/Carousel/MainContainer2';
import FeaturesSection from '../../components/Sections/FeaturesSection';
import MainContainer3 from '../../components/Carousel/MainContainer3';
import GalaPosterModal from '../../components/Servicepages/GalaPosterModal';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .about-page {
          background: #FDF8F0; /* beige très clair */
          position: relative;
          overflow: hidden;
        }

        /* Orbes dorées décoratives en fond */
        .about-page::before,
        .about-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.3;
          z-index: 0;
          pointer-events: none;
        }

        .about-page::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -10%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .about-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -5%;
          right: -5%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        /* Contenu principal au-dessus des orbes */
        .about-content {
          position: relative;
          z-index: 1;
        }

        /* Particules décoratives (optionnel) */
        .gold-particles {
          position: fixed;
          inset: 0;
          z-index: 0;
          pointer-events: none;
        }

        @media (max-width: 768px) {
          .about-page::before {
            width: 70vw;
            height: 70vw;
          }
          .about-page::after {
            width: 60vw;
            height: 60vw;
          }
        }
      `}</style>

      <motion.div
        className="about-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        {/* Particules dorées flottantes – peut être commenté si vous ne voulez pas de particules */}
        {/*
        <div className="gold-particles">
          <FloatingGoldParticles />
        </div>
        */}

        <div className="about-content">
        
          <Header />
          <BannerArea />
          <MainContainer />
          <MainContainer2 />
          <FeaturesSection />
          <MainContainer3 />
          <Footer />
         
        </div>
      </motion.div>
    </>
  );
};

export default About;